<template>
  <div class="main-container" id="product-detail">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="pnav"
      style="margin-bottom: 20px;"
      v-if="!yunModel"
    >
      <el-breadcrumb-item>{{ $t("header.menu.home") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("header.menu.product") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("query.detail") }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row class="clearfix">
      <div class="main fl">
        <div class="basic box clearfix">
          <div class="title">
            <i class="iconfont el-icon-eft-ziyuan4"></i>{{ $t("query.basic") }}
          </div>

          <div class="left">
            <div class="ld_route">
              <span
                >{{ Departure }}
                <img
                  v-lazy="'//doc.yctop.com/images/common/jiantou.png'"
                  alt=""
                />
                {{ Destination }}</span
              >
              <span class="product_tip bgr" v-if="productType == 'FLA'">{{
                $t("footer.sales")
              }}</span>
              <!-- <span class="product_tip bgy" v-if="productType=='PRO'">明星航线</span> -->
              <span class="icon_col">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Delay treasure"
                  placement="top"
                  v-if="delayTreasure == 1"
                >
                  <i class="iconfont el-icon-eft-ziyuan"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Trailer"
                  placement="top"
                  v-if="trailer == 1"
                >
                  <i class="iconfont el-icon-eft-ziyuan1"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Customs clearance"
                  placement="top"
                  v-if="customsDeclare == 1"
                >
                  <i class="iconfont el-icon-eft-ziyuan2"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Insured"
                  placement="top"
                  v-if="priceInsure == 1"
                >
                  <i class="iconfont el-icon-eft-bianzu"></i>
                </el-tooltip>
              </span>
            </div>
            <el-form
              :inline="true"
              v-model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="Packages">
                <el-input
                  class="search"
                  type="number"
                  v-model="pieces"
                  style="width:60px;"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="Gross Weight">
                <el-input
                  type="number"
                  class="search"
                  v-model="grossWeight"
                  style="width:100px;"
                  @change="weightChangeHandler"
                  :min="0"
                  :max="10000"
                  placeholder=""
                >
                  <template slot="suffix">
                    <span class="el-input__suffix">KG</span>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="Volume">
                <el-input
                  type="number"
                  class="search"
                  v-model="volume"
                  style="width:100px;"
                  @change="volumeChangeHandler"
                  :min="0"
                  :max="10000"
                  placeholder=""
                >
                  <template slot="suffix">
                    <span class="el-input__suffix">m³</span>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="Flight Date">
                <el-date-picker
                  v-model="flightDate"
                  type="date"
                  placeholder="Flight date"
                  style="width:130px; height:38px;"
                  @change="pickerdate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="isSure">{{
                  $t("query.calculation")
                }}</el-button>
              </el-form-item>
            </el-form>
            <template>
              <el-table
                ref="singleTable"
                :data="baseRate"
                highlight-current-row
                class="base_table"
                :cell-class-name="cellClass"
                style="width: 100%;height: 100%;"
              >
                <el-table-column align="center" prop="q1Price" label="+45">
                  <template slot-scope="scope">
                    <p v-if="!login && !yunModel && productType != 'FLA'">
                      {{
                        !!scope.row.q1PriceHide && scope.row.q1PriceHide != 0
                          ? "¥" + scope.row.q1PriceHide
                          : "-"
                      }}
                    </p>
                    <p v-else>
                      {{
                        !!parseFloat(scope.row.q1Price)
                          ? "¥" + scope.row.q1Price
                          : "-"
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="q2Price" label="+100">
                  <template slot-scope="scope">
                    <p v-if="!login && !yunModel && productType != 'FLA'">
                      {{
                        !!scope.row.q2PriceHide && scope.row.q2PriceHide != 0
                          ? "¥" + scope.row.q2PriceHide
                          : "-"
                      }}
                    </p>
                    <p v-else>
                      {{
                        !!parseFloat(scope.row.q2Price)
                          ? "¥" + scope.row.q2Price
                          : "-"
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="q3Price" label="+300">
                  <template slot-scope="scope">
                    <p v-if="!login && !yunModel && productType != 'FLA'">
                      {{
                        !!scope.row.q3PriceHide && scope.row.q3PriceHide != 0
                          ? "¥" + scope.row.q3PriceHide
                          : "-"
                      }}
                    </p>
                    <p v-else>
                      {{
                        !!parseFloat(scope.row.q3Price)
                          ? "¥" + scope.row.q3Price
                          : "-"
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="q4Price" label="+500">
                  <template slot-scope="scope">
                    <p v-if="!login && !yunModel && productType != 'FLA'">
                      {{
                        !!scope.row.q4PriceHide && scope.row.q4PriceHide != 0
                          ? "¥" + scope.row.q4PriceHide
                          : "-"
                      }}
                    </p>
                    <p v-else>
                      {{
                        !!parseFloat(scope.row.q4Price)
                          ? "¥" + scope.row.q4Price
                          : "-"
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="q5Price" label="+1000">
                  <template slot-scope="scope">
                    <p v-if="!login && !yunModel && productType != 'FLA'">
                      {{
                        !!scope.row.q5PriceHide && scope.row.q5PriceHide != 0
                          ? "¥" + scope.row.q5PriceHide
                          : "-"
                      }}
                    </p>
                    <p v-else>
                      {{
                        !!parseFloat(scope.row.q5Price)
                          ? "¥" + scope.row.q5Price
                          : "-"
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="density"
                  label="Density"
                  width="160px"
                >
                  <template slot-scope="scope">
                    <p>
                      {{
                        !!scope.row.densityOrigin
                          ? scope.row.densityOrigin
                          : "-"
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="cargoType"
                  label="Type"
                  width="140px"
                >
                  <template slot-scope="scope">
                    <p class="type">
                      {{ !!scope.row.cargoType ? scope.row.cargoType : "-" }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>

          <div class="right">
            <div class="fl" style="margin-left:34px;">
              <div class="activity">
                <div v-if="productType == 'FLA'">
                  <i class="iconfont el-icon-eft-countdown"></i>
                  <CommonTimer v-bind:st="EndDateTimer"></CommonTimer>
                </div>
              </div>
              <div class="msg ">
                <p>
                  {{ $t("query.route") }} <span>{{ FreightRoute }}</span>
                </p>
                <p>
                  {{ AirLine }}
                </p>
                <p>
                  {{ $t("query.time") }} <span>{{ FlightTime }}</span>
                </p>
                <div>
                  <p v-if="productType == 'FLA' && !!limitFlightData">
                    {{ $t("query.date") }} {{ limitFlightData }}
                  </p>
                  <p v-if="productType != 'FLA'">
                    {{ $t("query.datelimt") }} {{ StartDate }}— {{ EndDate }}
                  </p>
                </div>
              </div>
            </div>

            <div class="more fr">
              <div>
                <el-popover
                  placement="bottom-end"
                  trigger="click"
                  popper-class="same-popover"
                >
                  <template>
                    <el-table
                      :data="FlightInfo3"
                      class="base_table"
                      style="width: 100%"
                    >
                      <el-table-column
                        align="center"
                        prop="flightNo"
                        label="Flight Number"
                        width="130"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.flightNo &&
                              scope.row.flightNo != null &&
                              scope.row.flightNo != ""
                                ? scope.row.flightNo
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="departure"
                        label="Departure"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.departure &&
                              scope.row.departure != null &&
                              scope.row.departure != ""
                                ? scope.row.departure
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" prop="etd" label="ETD">
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.etd &&
                              scope.row.etd != null &&
                              scope.row.etd != ""
                                ? scope.row.etd
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="destination"
                        label="Destination"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.destination &&
                              scope.row.destination != null &&
                              scope.row.destination != ""
                                ? scope.row.destination
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" prop="eta" label="ETA">
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.eta &&
                              scope.row.eta != null &&
                              scope.row.eta != ""
                                ? scope.row.eta
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="flightPlan"
                        label="Flight Plan"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.flightPlan &&
                              scope.row.flightPlan != null &&
                              scope.row.flightPlan != ""
                                ? scope.row.flightPlan
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="flightModel"
                        label="Aircraft Type"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.flightModel &&
                              scope.row.flightModel != null &&
                              scope.row.flightModel != ""
                                ? scope.row.flightModel
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column
                        align="center"
                        prop="cutoffTime"
                        label="截单时间"
                        width="130"
                      >
                        <template slot-scope="scope">
                          <p class="CutOffTimefz">
                            {{
                              scope.row.cutoffTime &&
                              scope.row.cutoffTime != null &&
                              scope.row.cutoffTime != ""
                                ? scope.row.cutoffTime
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column> -->
                      <el-table-column
                        align="center"
                        prop="flightRemark"
                        label="Remark"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              scope.row.flightRemark &&
                              scope.row.flightRemark != null &&
                              scope.row.flightRemark != ""
                                ? scope.row.flightRemark
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                  <el-button slot="reference" type="text">{{
                    $t("query.info")
                  }}</el-button>
                </el-popover>
              </div>
              <div>
                <el-popover placement="bottom-end" trigger="click">
                  <div class="description">
                    <div class="row">
                      <div class="col1">{{ $t("query.area") }}</div>
                      <div class="col2">{{ DomainName }}</div>
                    </div>
                    <div class="row">
                      <div class="col1">{{ $t("query.expensedesc") }}</div>
                      <div class="col2">{{ CostDescription }}</div>
                    </div>
                    <div class="row">
                      <div class="col1">{{ $t("query.whether") }}</div>
                      <div class="col2">
                        {{
                          SeparationRatio == "" || !SeparationRatio
                            ? "No bubble"
                            : "Bubble-bubble ratio" + SeparationRatio + "%"
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col1">{{ $t("query.singlelimit") }}</div>
                      <div class="col2">{{ SingleProductWeight }}</div>
                    </div>
                    <div class="row">
                      <div class="col1">{{ $t("query.miniweight") }}</div>
                      <div class="col2">{{ WeightBottomLine }}</div>
                    </div>
                    <div class="row">
                      <div class="col1">
                        {{ $t("query.transitInformation") }}
                      </div>
                      <div class="col2">{{ TransportType }}</div>
                    </div>
                    <div class="row">
                      <div class="col1 end">{{ $t("query.otherdesc") }}</div>
                      <div class="col2">
                        {{ Remark }}
                      </div>
                    </div>
                  </div>
                  <el-button slot="reference" type="text">{{
                    $t("query.otherIntro")
                  }}</el-button>
                </el-popover>
              </div>
              <div>
                <el-popover
                  placement="bottom-end"
                  trigger="click"
                  popper-class="same-popover"
                >
                  <el-table
                    :data="dataSourceVal4"
                    style="width: 100%;max-height:376px;"
                    class="base_table"
                    @row-click="sameRowClick"
                  >
                    <el-table-column align="center" label="Airline">
                      <template slot-scope="scope">
                        <div class="precise_air">
                          <p>{{ scope.row.airline }}</p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      label="Transportation Route"
                      width="172px"
                    >
                      <template slot-scope="scope">
                        <p>{{ scope.row.freightRoute }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="+45" prop="q1Price">
                      <template slot-scope="scope">
                        <p>
                          {{
                            scope.row.q1Price == 0 ||
                            scope.row.q1Price == "NaN" ||
                            scope.row.q1Price == "undefined"
                              ? "-"
                              : "¥" + scope.row.q1Price
                          }}
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="+100" prop="q2Price">
                      <template slot-scope="scope">
                        <p>
                          {{
                            scope.row.q2Price == 0 ||
                            scope.row.q2Price == "NaN" ||
                            scope.row.q2Price == "undefined"
                              ? "-"
                              : "¥" + scope.row.q2Price
                          }}
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="+300" prop="q3Price">
                      <template slot-scope="scope">
                        <p>
                          {{
                            scope.row.q3Price == 0 ||
                            scope.row.q3Price == "NaN" ||
                            scope.row.q3Price == "undefined"
                              ? "-"
                              : "¥" + scope.row.q3Price
                          }}
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="+500" prop="q4Price">
                      <template slot-scope="scope">
                        <p>
                          {{
                            scope.row.q4Price == 0 ||
                            scope.row.q4Price == "NaN" ||
                            scope.row.q4Price == "undefined"
                              ? "-"
                              : "¥" + scope.row.q4Price
                          }}
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      label="+1000"
                      prop="q5Price"
                    >
                      <template slot-scope="scope">
                        <p>
                          {{
                            scope.row.q5Price == 0 ||
                            scope.row.q5Price == "NaN" ||
                            scope.row.q5Price == "undefined"
                              ? "-"
                              : "¥" + scope.row.q5Price
                          }}
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      label="Density"
                      prop="density"
                      width="160px"
                    >
                      <template slot-scope="scope">
                        <div>
                          <p>
                            {{ !!scope.row.density ? scope.row.density : "-" }}
                          </p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="cargoType"
                      label="Type"
                      width="140px"
                    >
                      <template slot-scope="scope">
                        <p class="type">
                          {{
                            !!scope.row.cargoType ? scope.row.cargoType : "-"
                          }}
                        </p>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button slot="reference" type="text">{{
                    $t("query.similarProduct")
                  }}</el-button>
                </el-popover>
              </div>
            </div>
          </div>
        </div>

        <div class="serve box">
          <div class="title clearfix">
            <div class="fl">
              <i class="iconfont el-icon-eft-shangmenlanhuo-youcang"></i>
              {{ $t("query.oneServe") }}
            </div>
            <div class="right fr">
              <span> {{ $t("query.currency") }}</span>
              <span class="col2">{{ $t("query.estimate") }}</span>
            </div>
          </div>
          <div class="serve_content">
            <div class="serve1 applyServe">
              <el-checkbox
                v-model="checkedApply"
                @change="textCheckedApply()"
                >{{ $t("query.declaration") }}</el-checkbox
              >
              <span class="selectplace">{{
                $t("query.declarationpalce")
              }}</span>
              <template>
                <el-select
                  v-model="syscodeApply"
                  placeholder="Please choose"
                  clearable
                  @change="applyChanged"
                  :disabled="disabledApply"
                >
                  <el-option
                    v-for="item in chargeList"
                    :key="item.departure"
                    :label="item.departure ? item.departure : item.depName"
                    :value="item.departure"
                  >
                  </el-option>
                </el-select>
              </template>
              <div>
                <p class="haveselected serve_col" v-if="checkedApply == true">
                  {{ $t("query.selected") }}
                </p>
                <div class="serve_col fr">
                  <span class="gray">{{ $t("query.cny") }}</span>
                  <p>
                    <span
                      v-if="
                        syscodeApply != '' &&
                          checkedApply == true &&
                          chargePrice != ''
                      "
                      class="syscodeApply != ''? red : gray"
                      >CNY￥{{ chargePrice }}</span
                    >
                    <span
                      v-else-if="
                        syscodeApply != '' &&
                          checkedApply == true &&
                          chargePrice == ''
                      "
                      class="gray"
                      >{{ $t("query.singleAsk") }}</span
                    >
                    <span v-else class="gray">-</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="serve1 deliveryserve">
              <el-checkbox
                v-model="checkedPickUp"
                @change="textCheckedPickUp()"
                >{{ $t("query.delivery") }}</el-checkbox
              >
              <span class="selectplace">{{ $t("query.deliveryplace") }}</span>
              <template>
                <el-select
                  class="select_1"
                  v-model="cityNames"
                  placeholder="Please choose"
                  :disabled="disabledPickUp"
                  @change="cityChanged"
                >
                  <el-option
                    v-for="(item, index) in takeDeliveryInfoList"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>

                <el-select
                  class="select_2"
                  v-model="areaNames"
                  placeholder="Please choose"
                  :disabled="disabledPickUp"
                  :loading="loadingCity"
                  @change="selectSyscode(areaNames)"
                >
                  <el-option
                    v-for="(item, index) in deliveryInfoList"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </template>
              <div class="serve_col fr">
                <p class="name gray">{{ $t("query.cny") }}</p>
                <p>
                  <span
                    v-if="nationPrice != 0 && nationPrice != null"
                    class="areaNames != ''? red : gray"
                    >CNY￥{{ nationPrice }}</span
                  >
                  <span
                    v-else-if="
                      (areaNames != '' &&
                        grossWeight != '' &&
                        volume != '' &&
                        nationPrice == 0) ||
                        (areaNames != '' &&
                          grossWeight != '' &&
                          volume != '' &&
                          nationPrice == null)
                    "
                    >{{ $t("query.singleAsk") }}</span
                  >
                  <span v-else class="gray">-</span>
                </p>
              </div>
              <div
                v-if="checkedPickUp == true && airportName != ''"
                class="serve_col place"
              >
                {{ $t("query.handinplace") }} <b>{{ airportName }}</b>
              </div>
            </div>
            <div class="serve1 foreign_serve">
              <el-checkbox
                v-model="checkedServe"
                @change="textCheckedServe()"
                >{{ $t("query.overseas") }}</el-checkbox
              >
              <span class="selectplace">{{ $t("query.overseasplace") }}</span>
              <template>
                <el-select
                  class="select_1"
                  v-model="cityDestination"
                  placeholder="Please choose"
                  :disabled="disabledServe"
                  @change="cityDestinationChanged(cityDestination)"
                >
                  <el-option
                    v-for="item in foreignServeList"
                    :key="item.departure"
                    :label="item.departure ? item.departure : item.depName"
                    :value="item.departure"
                  >
                  </el-option>
                </el-select>
              </template>
              <div
                v-if="foreignChargeList.length == 0 && checkedServe == true"
                class="serve_col fr"
              >
                <p class="name gray">{{ $t("query.singleAsk") }}</p>
              </div>
            </div>

            <div
              class="serve1 clearfix"
              v-if="
                cityDestination != '' &&
                  checkedServe == true &&
                  foreignChargeList.length > 0
              "
            >
              <table class="el-table other-table fr">
                <tbody v-if="foreignChargeList != ''">
                  <tr v-for="(item, index) in foreignChargeList">
                    <td class="td1 gray">{{ item.chargeName }}</td>
                    <td class="td2 gray">{{ item.currencyUnit }}</td>
                    <td
                      v-if="
                        cityDestination != '' &&
                          checkedServe == true &&
                          item.chargePrice != 0
                      "
                      class="td3 red"
                    >
                      {{ item.chargePrice }}
                    </td>
                    <td
                      v-if="item.chargePrice == 0 || !item.chargePrice"
                      class="td3 gray"
                    >
                      {{ $t("query.singleAsk") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="other_cost box" v-if="ChargeInfo8 != ''">
          <el-collapse>
            <el-collapse-item>
              <template slot="title" class="title">
                <i class="iconfont el-icon-eft-qiandai"></i
                >{{ $t("query.possiblecost") }}
              </template>
              <div class="content clearfix gray">
                <table class="el-table other-table fr">
                  <tbody :data="ChargeInfo8">
                    <tr v-for="(item, index) in ChargeInfo8">
                      <td class="td1 gray">
                        {{ item.chargeName }}
                        <el-popover
                          placement="right-start"
                          trigger="hover"
                          popper-class="desc-popover"
                          v-if="item.description && item.description != ''"
                        >
                          <div class="description">
                            <div class="desc1">{{ $t("query.details") }}:</div>
                            <div class="desc2">{{ item.description }}</div>
                          </div>
                          <el-button slot="reference" type="text"
                            ><i class="el-icon-question"></i
                          ></el-button>
                        </el-popover>
                      </td>
                      <td class="td2 gray">{{ $t("query.cny") }}</td>
                      <td class="td3 gray" v-if="item.chargePrice">
                        ￥{{ item.chargePrice }}
                      </td>
                      <td class="td3 gray" v-else>
                        {{ $t("query.singleAsk") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <div class="aside fl">
        <div class="cost">
          <div class="title clearfix">
            <i class="iconfont el-icon-eft-calc"></i>
            {{ $t("query.costCalculation") }}
          </div>
          <div class="aside_content">
            <div class="aside_row row1 clearfix">
              <!-- 计算 -->
              <div class="col-1 fl">{{ $t("query.airfreight") }}</div>
              <div class="col-2 fr" v-if="freight != 0">CNY￥{{ freight }}</div>
              <div class="col-2 fr" v-else>-</div>
            </div>
            <div
              class="aside_row clearfix"
              v-for="(item, index) in ChargeInfo3"
            >
              <div class="col-1 fl">{{ item.chargeName }}</div>
              <div class="col-2 fr" v-if="item.chargePrice">
                CNY￥{{ item.chargePrice }}
              </div>
            </div>
            <div
              class="aside_row row1 clearfix"
              v-if="
                checkedApply == true ||
                  checkedPickUp == true ||
                  checkedServe == true
              "
            >
              <div class="col-1 fl">{{ $t("query.airfreightAdd") }}</div>
            </div>

            <div
              class="aside_row clearfix"
              v-if="syscodeApply != '' && checkedApply == true && !!chargePrice"
            >
              <div class="col-1">{{ $t("query.customsfee") }}</div>
              <div class="col-2 fr">CNY￥{{ chargePrice }}</div>
            </div>
            <div
              class="aside_row clearfix"
              v-if="areaNames != '' && checkedPickUp == true && !!nationPrice"
            >
              <div class="col-1">{{ $t("query.deliveryfee") }}</div>
              <div
                class="col-2 fr"
                v-if="areaNames != '' && checkedPickUp == true"
              >
                CNY￥{{ nationPrice }}
              </div>
              <div class="col-2 fr" v-else>CNY￥0.00</div>
            </div>
            <div
              class="aside_row clearfix"
              v-if="
                cityDestination != '' &&
                  checkedServe == true &&
                  !!foreignChargeAll
              "
            >
              <div class="col-1">{{ $t("query.overseasfee") }}</div>
              <div class="col-2 fr">CNY￥{{ foreignChargeAll }}</div>
            </div>
          </div>
          <div class="total">
            <div class="total_row clearfix">
              <div class="total_title">{{ $t("query.total") }}</div>
              <p class="fr col-2">CNY￥{{ totalCharge ? totalCharge : "-" }}</p>
              <div class="col-1 model">
                <p
                  v-if="
                    checkedServe == true &&
                      cityDestination != '' &&
                      currencyUnit != '人民币'
                  "
                >
                  {{ $t("query.rate") }} {{ Rate }}
                </p>
              </div>
              <div class="col-2 fr">
                <div v-if="dollar != 0 && currencyUnit != '人民币'">
                  <p>{{ dollar }} {{ unit }}</p>
                </div>
              </div>
            </div>
            <div class="total_row clearfix" v-if="dollar != 0">
              <div class="col-1 fl sub">{{ $t("query.exchange") }}</div>
              <div class="col-2 fr sub2" v-if="allCharge">
                CNY￥{{ allCharge }}
              </div>
              <div class="col-2 fr sub2" v-else>CNY￥0.00</div>
            </div>
          </div>
          <el-button v-if="!!yunModel" @click="gotoSaas" class="active_no">
            {{ $t("query.inquiry") }}</el-button
          >
          <el-button v-else-if="!login" @click="toLogin" class="active_no">{{
            $t("query.login")
          }}</el-button>
          <div v-else>
            <el-button
              v-if="productType == 'PRO' || productType == 'NOR'"
              @click="orderFactory()"
            >
              {{ $t("query.booknow") }}
            </el-button>
            <div v-if="productType == 'FLA'">
              <div v-if="statusFLA != 'OFF' && productPercentage != '100'">
                <el-button v-if="statusFLA == 'WAIT'" class="active_no">{{
                  $t("query.start")
                }}</el-button>
                <el-button v-if="statusFLA == 'ON'" @click="orderFactory()">
                  {{ $t("query.being") }}
                </el-button>
              </div>
              <div v-else-if="statusFLA != 'OFF' && productPercentage == '100'">
                <el-button class="active_end">{{
                  $t("query.soldOut")
                }}</el-button>
              </div>
              <el-button v-else class="active_end">{{
                $t("query.end")
              }}</el-button>
            </div>
          </div>
          <div class="word">{{ $t("query.word") }}</div>
        </div>

        <div class="wx_tip" v-if="productType == 'PRO' || productType == 'NOR'">
          <div class="tip_title">
            <img
              v-lazy="'//doc.yctop.com/images/common/kefu-3.png'"
              style="width: 24px; height:34px"
              alt=""
            />
            <p>{{ $t("query.tips") }}</p>
          </div>
          <div class="tip_content">
            {{ $t("query.tips1") }}<br />
            {{ $t("query.tips2") }}<span>{{ $t("query.tips3") }}</span
            >，<span>{{ $t("query.tips4") }}</span
            >{{ $t("query.tips5") }}
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<style scoped>
@import "~@/assets/css/view/product/detail.css";
</style>
<script type="babel">
import CommonTimer from "@/components/timer.vue";
import LOKIJS from 'lokijs';
import YC_REQUEST_HANDLER from "@/api/request.js";
import UTILS from "@/utils/utils.js";
import DBUtils from "@/utils/dbUtils.js";
import { mapState, mapActions, mapGetters } from 'vuex';
import URLSearchParams from 'url-search-params';
export default {
    components: {
        CommonTimer,
    },
    data: function() {
        return {
            highlightedRowIndex: -1,
            AirLine: '',
            productType: 'NOR',
            supplierID: '',
            storeCode: '',
            airlineCode: '',
            ProductImage: '',
            dataSourceVal1: [], //
            dataSourceVal3: [], //
            dataSourceVal4: [], //同类产品
            SportPriceInfo: [],
            FlightInfo3: [],
            ChargeInfo3: [],
            requiredPrice: 0,
            ChargeInfo8: [],
            baseRate: [],
            pIdx: '',
            pCnt: 1,
            PageSize: '5',
            CurrentPage: '1',
            productcode: '',
            pricecode: '',
            org_id: '',
            Airlinename: '',
            density: '', //Density: '',
            StartDate: '',
            EndDate: '',
            MINPRICE: '',
            NORMALPRICE: '',
            Q1PRICE: '',
            Q2PRICE: '',
            Q3PRICE: '',
            Q4PRICE: '',
            Q5PRICE: '',
            Departure: '',
            FreightRoute: '',
            Destination: '',
            totalGrossWeight: '',
            totalVolume: '',
            totalChargeableWeight: '',
            flightDate: '',
            ETA: '',
            ETD: '',
            DomainName: '',
            CostDescription: '',
            SeparationRatio: '',
            SizeTopLine: '',
            SingleProductWeight: '',
            WeightBottomLine: '',
            LithiumType: '',
            TransportType: '',
            Remark: '',
            DepartureName: '',
            DestinationName: '',
            grossWeight: '',
            volume: '',
            formInline: '',
            pieces: '',
            FlightTime: '',
            serveCharge: [],
            chargeableWeight: '',
            departure: '',
            type: 0,
            name: '报关费',
            chargeType: '',
            sysCodePickUp: '',
            chargeList: [],
            syscodeApply: '',
            city: '',
            area: '',
            takeDeliveryInfoList: [],
            deliveryInfoList: [],
            // proviceName:'',
            cityNames: '',
            areaNames: '',
            loadingCity: false,
            cityDestination: '',
            areaDestination: '',
            foreignServeList: [],
            foreignInfoList: [],
            areaName: '',
            freight: '', //空运费
            nationPrice: '', //国内提货
            foreignChargeList: [],
            chargeName: '',
            price: '',
            dollar: 0, //海外送货
            Rate: '', //汇率
            currencyUnit: '', //海外服务币种
            checkedApply: false,
            checkedPickUp: false,
            checkedServe: false,
            disabledApply: true,
            disabledPickUp: true,
            disabledServe: true,
            chargePrice: 0, //国内报关
            Recommend: '',
            deliveryCode: '',
            airportName: '',
            cityOriginArray: [],
            airportDB: null,
            volumeWeight: '',
            CNY:0,
            statusFLA:'',
            EndDateTimer:'',
            startDateTimer:'',
            nowTime:'',
            baseCharge:'',
            limitFlightData:'',
            delayTreasure:'',
            trailer:'',
            customsDeclare:'',
            priceInsure:'',
            productPercentage:'',
            unit:'',
        }

    },
    mounted: async function () {
        var vm = this;
        var productcode = vm.productcode = UTILS.getUrlKey('productcode'),
            pricecode = vm.pricecode = UTILS.getUrlKey('pricecode')
        var productType = vm.productType = UTILS.getUrlKey('productType');
        var departure = vm.Departure = UTILS.getUrlKey('departure');
        var destination = vm.Destination = UTILS.getUrlKey('destination')
        vm.flightDate = UTILS.getUrlKey('flightdate'),
            vm.volume = UTILS.getUrlKey('volume')
        vm.grossWeight = UTILS.getUrlKey('weight')
        vm.pieces = UTILS.getUrlKey('pieces')
        vm.syscodeApply = UTILS.getUrlKey('syscodeApply')
        vm.cityNames = UTILS.getUrlKey('cityNames')
        vm.areaNames = UTILS.getUrlKey('areaNames')
        vm.chargePrice = UTILS.getUrlKey('chargePrice')
        vm.nationPrice = UTILS.getUrlKey('nationPrice')
        vm.cityDestination = UTILS.getUrlKey('cityDestination') ? (UTILS.getUrlKey('cityDestination').substring(0,4)=='null' || (UTILS.getUrlKey('cityDestination').substring(0,1)=='?' ? '': UTILS.getUrlKey('cityDestination').substring(0,3) ) ): '';
        vm.checkedApply = !!vm.syscodeApply
        vm.checkedPickUp=!!vm.areaNames
        vm.checkedServe= !!vm.cityDestination
        UTILS.getUrlKey('cityDestination') && vm.cityDestinationChanged( vm.cityDestination)
        vm.dataSource1(productcode, pricecode, productType, departure, destination);
        vm.dataSource4(vm.PageSize, vm.CurrentPage, departure, destination, productcode);
        // vm.loadDataSource();
        vm.loadTakeDelivery();
        vm.loadRate();
        await vm.initCityDB()
        vm.density=vm.densityComputed
        var timer=window.setInterval(() => {
            vm.nowTime= vm.dateFormat();
            if(vm.nowTime>=vm.EndDateTimer ){
                vm.statusFLA='OFF'
                window.clearInterval(timer)
            }
        }, 1000);

        vm.disabledApply = !vm.checkedApply
        vm.disabledPickUp = !vm.checkedPickUp
        vm.disabledServe = !vm.checkedServe
    },
    computed: {
        totalCharge: function () {
            return (Number(this.freight) + Number(this.requiredPrice) + Number(this.chargePrice) + Number(this.nationPrice)).toFixed(2)

        },
        // 折合人民币
        allCharge: function () {
            return (Number(this.freight) + Number(this.requiredPrice) + Number(this.foreignChargeAll) + Number(this.chargePrice) + Number(this.nationPrice)).toFixed(2)

        },
        densityComputed: function () {
            return parseInt(parseFloat(this.grossWeight) / parseFloat(this.volume));
        },
        foreignChargeAll:function(){
            return  Number((this.dollar*this.Rate).toFixed(2)) + Number( this.CNY);
        },
        ...mapState({
            user: state => state.user,
            token: state => state.token,
            yunModel: state => state.yunModel,
        }),
        ...mapGetters({
            login: 'checkLogin',
        })

    },


    methods: {
        dateFormat() {
            var date=new Date();
            var year=date.getFullYear();
            var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
            var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
            var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
            var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
            var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
            // 拼接
            return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
        },
        initCityDB: async function () {
            this.airportDB = await DBUtils.getDBPorts()
            var dbCity = this.queryPort(this.Departure.toUpperCase());
            dbCity.some((item, i) =>{
                if(item.pc == this.Departure.toUpperCase()){
                    this.airportName = item.pn
                    return true;
                }
            })
        },
        queryPort: function (query) {
            var patt = '^' + query;
            var reg = new RegExp(patt, "");
            return this.airportDB.where(function (obj) {
                return reg.test(obj.pc)
            });
        },
        textCheckedApply() {
            var vm = this;
            if (vm.checkedApply == true) {
                vm.disabledApply = false;
                vm.loadServeSource();
            } else {
                vm.disabledApply = true;
                vm.syscodeApply = '';
                vm.chargePrice = 0;

            }
        },
        textCheckedPickUp() {
            var vm = this;
            if (vm.checkedPickUp == true) {
                if (!vm.grossWeight || !vm.volume) {
                    vm.$bus.emit('commmon-notification', null, 'Please enter the gross weight/volume of the goods!')

                }
                vm.disabledPickUp = false;
            } else {
                vm.disabledPickUp = true;
                vm.cityNames = '';
                vm.areaNames = '';
                vm.nationPrice = '';
            }
        },
        textCheckedServe() {
            var vm = this;
            if (vm.checkedServe == true) {
                vm.disabledServe = false;
                vm.loadForeignServeList();
            } else {
                vm.disabledServe = true;
                vm.cityDestination = '';
                vm.areaDestination = '';
                vm.dollar = 0;
            }
        },
        weightChangeHandler: function (event) {
            if (event != this.grossWeight) {
                if (event) {
                    this.grossWeight = Number(event).toFixed(2);
                }
            }
            if (event) {
                this.grossWeight = Number(event).toFixed(2);
            }
            if (event <= 0) {
                this.grossWeight = Number(Math.abs(event)).toFixed(2);
            }
            this.updateChargeWeight();
            this.updateProportion();
        },
        volumeChangeHandler: function (event) {
            if (event != this.volume) {
                if (event) {
                    this.volume = Number(event).toFixed(2);
                }
            }
            if (event) {
                this.volume = Number(event).toFixed(2);
            }
            if (event <= 0) {
                this.volume = Number(Math.abs(event)).toFixed(2);
            }
            this.updateChargeWeight();
            this.updateProportion();
        },
        pickerdate: function (flightDate) {
            var vm = this;
            if (flightDate) {
                vm.flightDate = flightDate.getFullYear() + '-' + vm.timeAdd(Number(flightDate.getMonth() + 1)) + '-' + vm.timeAdd(flightDate.getDate());

            } else {
                vm.flightDate = '';
            }
        },
        piecesChangeHandler: function () {
            var pieces = this.pieces
            this.updateChargeWeight();
            this.updateProportion();

        },
        updateChargeWeight: function () {
            var totalGrossWeight = this.grossWeight;
            var volume = this.volume;
            if (!totalGrossWeight) totalGrossWeight = 0;
            if (!volume) volume = 0;
            // var volumeWeight = (
            //     (Math.round((volume * 1000000) / 6000))
            // ).toFixed(2);
            var volumeWeight = Math.ceil((volume * 1000000) / 6000)
            this.chargeableWeight = Math.max(totalGrossWeight, volumeWeight);
            if (this.chargeableWeight == 0) {
                this.chargeableWeight = "";
            }
        },
        updateProportion: function () {
            var density = parseInt(parseFloat(this.grossWeight) / parseFloat(this.volume));
            if (density) {
                this.density = density;
            } else {
                this.density = "";
            }
        },
        toPercent: function(point){
            point=point.toFixed(2)
            if (point==0) {
                return 0;
            }
            if (point==1 || point <=0 ) {
                return '100';
            }
            var str=parseInt(Number(point*100))
            return str;
        },
        dataSource1: function (productcode, price_syscode, productType, departure, destination) {

            var url = '/api/product/query/detail',
            formData = {
                productCode: productcode,
                priceCode: price_syscode,
            },
            successCallBack = async function (response) {
            // if (response.code == 200) {
                if(productType=='FLA' && !!response.flashSale.flightDate ){
                    _this.limitFlightData= _this.flightDate=response.flashSale.flightDate
                }
                 if(productType=='FLA' && !!response.flashSale ){
                    _this.productPercentage=_this.toPercent( (response.flashSale.transportTotalWeight-response.flashSale.transportSurplusWeight) /response.flashSale.transportTotalWeight)
                }
                _this.AirLine = response.product.airline
                if(productType){
                    _this.productType=productType
                }else{
                        _this.productType = response.product.productType
                }

                _this.supplierID = response.product.supplierCode
                _this.storeCode = response.product.storeCode
                _this.airlineCode = response.product.airline
                _this.StartDate = response.product.startDate.substr(0, 10).replace(/-/g, ".");
                _this.EndDate = response.product.endDate.substr(0, 10).replace(/-/g, ".");
                _this.EndDateTimer = response.product.endDate
                _this.startDateTimer=response.product.startDate
                _this.delayTreasure= response.product.delayTreasure ? response.product.delayTreasure : 0
                _this.trailer= response.product.trailer ? response.product.trailer : 0
                _this.customsDeclare= response.product.customsDeclare ? response.product.customsDeclare : 0
                _this.priceInsure=response.product.priceInsure ? response.product.priceInsure : 0
                if(response.flashSale){
                    _this.statusFLA=response.flashSale.status
                }
                await DBUtils.getAirlineZhName(response.product.airline).then(res=>{
                    _this.Airlinename=res
                });
                if (response.priceList) {
                    if (response.priceList.length) {
                        _this.baseRate = response.priceList;
                    } else {
                        var SpiArr = [];
                        SpiArr.push(response.priceList)
                        _this.baseRate = SpiArr;
                    }
                }

                for (i = 0; i < _this.baseRate.length; i++) {
                    var temp = _this.baseRate[i];
                    console.log(temp.densityBottomLine, temp.densityTopLine)
                    temp.densityOrigin = temp.density
                    if(temp.densityOrigin) {
                        let o = temp.densityOrigin,
                            dArray = o.split("<"),
                            t = ''
                        if(dArray.length == 3) {
                            t = dArray[0].replace('=', '') + '<' + dArray[1].replace('=', '') + '≤' + dArray[2].replace('=', '')
                        } else if (dArray.length == 2) {
                            t = dArray[1].replace('=', '') + '≥' + dArray[0].replace('=', '')
                        }
                        t && (temp.densityOrigin = t)
                    }
                    temp.density = UTILS.getDensity(temp.density);
                    temp.minPrice = parseFloat(temp.minPrice).toFixed(2);
                    temp.normalPrice = parseFloat(temp.normalPrice).toFixed(2);
                    temp.q1Price = parseFloat(temp.q1Price).toFixed(2);
                    temp.q2Price = parseFloat(temp.q2Price).toFixed(2);
                    temp.q3Price = parseFloat(temp.q3Price).toFixed(2);
                    temp.q4Price = parseFloat(temp.q4Price).toFixed(2);
                    temp.q5Price = parseFloat(temp.q5Price).toFixed(2);
                    if(!_this.login && !_this.yunModel && _this.productType !='FLA'){
                        temp.q1PriceHide = UTILS.replacePosition(temp.q1Price)
                        temp.q2PriceHide = UTILS.replacePosition(temp.q2Price)
                        temp.q3PriceHide = UTILS.replacePosition(temp.q3Price)
                        temp.q4PriceHide = UTILS.replacePosition(temp.q4Price)
                        temp.q5PriceHide = UTILS.replacePosition(temp.q5Price)
                    }
                    if (_this.baseRate[i].priceCode == price_syscode) {
                        // _this.MINPRICE = _this.baseRate[i].minPrice;
                        // _this.NORMALPRICE = _this.baseRate[i].normalPrice;
                        // console.log(_this.baseRate[i].priceCode)
                        _this.Q1PRICE = _this.baseRate[i].q1Price;
                        _this.Q2PRICE = _this.baseRate[i].q2Price;
                        _this.Q3PRICE = _this.baseRate[i].q3Price;
                        _this.Q4PRICE = _this.baseRate[i].q4Price;
                        _this.Q5PRICE = _this.baseRate[i].q5Price;
                        
                        _this.DomainName = _this.baseRate[i].domainName;
                        _this.CostDescription = _this.baseRate[i].costDescription;
                        _this.SeparationRatio = _this.baseRate[i].separationRatio;
                        _this.SizeTopLine = _this.baseRate[i].sizeTopLine;
                        _this.SingleProductWeight = _this.baseRate[i].singleProductWeight;
                        _this.WeightBottomLine = _this.baseRate[i].weightBottomLine;
                        _this.LithiumType = _this.baseRate[i].lithiumType;
                        _this.TransportType = _this.baseRate[i].transportType;
                        _this.Remark = _this.baseRate[i].remark;
                        _this.FlightTime = _this.baseRate[i].flightTime;
                        _this.FreightRoute = _this.baseRate[i].freightRoute;
                        _this.Departure = _this.baseRate[i].departure,
                        _this.Destination = _this.baseRate[i].destination;
                        _this.DepartureName = _this.baseRate[i].departureName;
                        _this.DestinationName = _this.baseRate[i].destinationName;
                        if(!_this.baseRate[i].departure){
                            for(var i=0;i<_this.FlightInfo3.length;i++){
                                _this.Departure=_this.FlightInfo3[0].departure
                                _this.Destination=_this.FlightInfo3[0].destination
                            }
                        }
                        if (_this.grossWeight && _this.volume) {
                            _this.freightCalculate();
                            _this.pricecode=_this.baseRate[i].priceCode
                        }
                    }
                }
                // 必选杂费
                if(response.chargeList.length){
                    if (response.chargeList.length > 0) {
                        _this.ChargeInfo3 = response.chargeList;

                    } else {
                        var ChargeArr = [];
                        ChargeArr.push(response.chargeList)
                        _this.ChargeInfo3 = ChargeArr;
                    }
                    for (var j = 0; j < _this.ChargeInfo3.length; j++) {
                        if (_this.ChargeInfo3[j].chargeUnit == 3) {
                            _this.baseCharge=_this.ChargeInfo3[j].chargePrice
                        }

                    }
                    _this.mustChargeAll(_this.grossWeight)
                }else{
                    _this.ChargeInfo=[]
                    _this.requiredPrice=0
                }
                // 可能杂费
                if (response.possibleList.length > 0) {
                    _this.ChargeInfo8 = response.possibleList;
                } else {
                    var ChargeArr = [];
                    ChargeArr.push(response.possibleList)
                    _this.ChargeInfo8 = ChargeArr;
                }
                // 航班信息
                if (response.flightInfo) {
                    let flightList=[]
                    if(response.flightInfo.first){
                        flightList=flightList.concat(response.flightInfo.first);
                    }
                    if(response.flightInfo.second){
                        flightList=flightList.concat(response.flightInfo.second);
                    }
                    if(response.flightInfo.third){
                        flightList=flightList.concat(response.flightInfo.third);
                    }
                    _this.FlightInfo3 = flightList;
                    
                } else {
                    _this.FlightInfo3 = [];
                }

                // _this.postLog();

            // }

            },
            failCallBack = function (err) {

            },
            _this = this

            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)
        },
        mustChargeAll:function(grossWeight){
            var _this=this
            _this.requiredPrice=0
                for (var j = 0; j < _this.ChargeInfo3.length; j++) {
                    if (_this.ChargeInfo3[j].chargeUnit == 3) {
                        var money= Number((_this.baseCharge) * grossWeight).toFixed(2)
                        money = money < _this.ChargeInfo3[j].miniPrice ? _this.ChargeInfo3[j].miniPrice : money;
                        _this.ChargeInfo3[j].chargePrice=money

                    }
                    _this.requiredPrice += Number(_this.ChargeInfo3[j].chargePrice)

                }

        },
        // 同类产品
        dataSource4: function (PageSize, CurrentPage, departure, destination, nproductcode) {
            var vm = this
            var url = '/api/product/query/list',
            params = {
                departure: departure,
                destination: destination,
                // transit: '',
                airline: '',
                density: '',
                // densityStr: '',
                packagingType: '',
                flightDate: '',
                grossWeight: 1,
                volume: 1,
                orderByColumn: 'total',
                orderRule: 'desc',
                notProductCode: nproductcode,
                sublist: 0,
                pageIndex: CurrentPage,
                pageSize: PageSize,
                requestSource: 'WEB-YCTOP',
                logFlag: false,
                token: vm.token || ''
            }
            var successCallBack = function (res) {
            if(res.productList.length){
                if (res.productList.length>0) {
                        vm.dataSourceVal4 = res.productList;
                    } else {
                        var dataArr4 = [];
                        dataArr4.push(res.productList);
                        vm.dataSourceVal4 = dataArr4;
                    }
            }else{
                vm.dataSourceVal4=[]
            }

                for (var i = 0; i < vm.dataSourceVal4.length; i++) {
                    var temp = vm.dataSourceVal4[i];
                    temp.minPrice = parseFloat(temp.minPrice).toFixed(2);
                    temp.normalPrice = parseFloat(temp.normalPrice).toFixed(2);
                    temp.q1Price = parseFloat(temp.q1Price).toFixed(2);
                    temp.q2Price = parseFloat(temp.q2Price).toFixed(2);
                    temp.q3Price = parseFloat(temp.q3Price).toFixed(2);
                    temp.q4Price = parseFloat(temp.q4Price).toFixed(2);
                    temp.q5Price = parseFloat(temp.q5Price).toFixed(2);
                    if(!vm.login && !vm.yunModel && temp.productType !='FLA'){
                        temp.q1Price = UTILS.replacePosition(temp.q1Price)
                        temp.q2Price = UTILS.replacePosition(temp.q2Price)
                        temp.q3Price = UTILS.replacePosition(temp.q3Price)
                        temp.q4Price = UTILS.replacePosition(temp.q4Price)
                        temp.q5Price = UTILS.replacePosition(temp.q5Price)
                    }
                }

            }
            var failCallBack = function (err) {

            }
            YC_REQUEST_HANDLER.postQuery(url, params, successCallBack, failCallBack)

        },

        sameRowClick: function(row, column, event){
            var Productcode=row.productCode,
                priceSyscode=row.priceSyscode,
                productType=row.productType,
                departure=row.departure,
                destination=row.destination;
            if(!Productcode){
                return false;
            }
            let query={
                    productcode: Productcode,
                    pricecode: priceSyscode,
                    productType: productType,
                    departure: departure,
                    destination: destination,
                    yunModel: this.yunModel,
                    flightdate: this.flightDate,
                    volume: this.volume,
                    weight: this.grossWeight,
            }
            let similarProduct = this.$router.resolve({ name: 'ProductDetailPage', query:query });
			window.open(similarProduct.href, '_blank');
        },
        isSure: function () {
            this.mustChargeAll(this.grossWeight)
            var _this = this;
            if (!_this.pieces || !_this.grossWeight || !_this.volume) {
                _this.$bus.emit('commmon-notification', null, 'Please enter the packages of goods/gross weight/volume!')
                return false
            }
            _this.density = parseInt(parseFloat(_this.grossWeight) / parseFloat(_this.volume))
            if(_this.checkedPickUp==true){
                _this.selectSyscode( _this.areaNames)
            }

            if(_this.checkedServe==true){
                _this.cityDestinationChanged(_this.cityDestination)
            }
            for (var i = 0; i < _this.baseRate.length; i++) {
                let unit = _this.baseRate[i],
                    top = unit.densityTopLine ? unit.densityTopLine : 10000,
                    bottom = unit.densityBottomLine ? unit.densityBottomLine : 1;
                if (_this.density < top && _this.density >= bottom) {
                    _this.Q1PRICE = unit.q1Price;
                    _this.Q2PRICE = unit.q2Price;
                    _this.Q3PRICE = unit.q3Price;
                    _this.Q4PRICE = unit.q4Price;
                    _this.Q5PRICE = unit.q5Price;
                    
                    _this.pricecode=unit.priceCode
                    _this.DomainName = unit.domainName;
                    _this.CostDescription = unit.costDescription;
                    _this.SeparationRatio = unit.separationRatio;
                    _this.SingleProductWeight = unit.singleProductWeight;
                    _this.WeightBottomLine = unit.weightBottomLine;
                    _this.TransportType = unit.transportType;
                    _this.Remark = unit.remark;
                    _this.freightCalculate();
                    break;
                }else {
                    _this.Q1PRICE = _this.baseRate[0].q1Price;
                    _this.Q2PRICE = _this.baseRate[0].q2Price;
                    _this.Q3PRICE = _this.baseRate[0].q3Price;
                    _this.Q4PRICE = _this.baseRate[0].q4Price;
                    _this.Q5PRICE = _this.baseRate[0].q5Price;
                    
                    _this.pricecode=_this.baseRate[0].priceCode
                    _this.DomainName = _this.baseRate[0].domainName;
                    _this.CostDescription = _this.baseRate[0].costDescription;
                    _this.SeparationRatio = _this.baseRate[0].separationRatio;
                    _this.SingleProductWeight = _this.baseRate[0].singleProductWeight;
                    _this.WeightBottomLine = _this.baseRate[0].weightBottomLine;
                    _this.TransportType = _this.baseRate[0].transportType;
                    _this.Remark = _this.baseRate[0].remark;
                    _this.freightCalculate();
                }

            }


        },

        freightCalculate: function () {
            var vm = this;
            var totalGrossWeight = Math.round(vm.grossWeight);
            var volumeWeight = vm.volumeWeight =Math.ceil((vm.volume * 1000000) / 6000); //计费重量
            // vm.chargeableWeight = Math.max(totalGrossWeight, volumeWeight); //取计费重量与实际重量的大者
            // 分泡结算重量
            if(totalGrossWeight>=volumeWeight){
                vm.chargeableWeight=totalGrossWeight
            }else {
                vm.chargeableWeight=!!vm.SeparationRatio && vm.SeparationRatio !=0 ?  Math.ceil( totalGrossWeight+( (volumeWeight-totalGrossWeight)*(1- Number(vm.SeparationRatio)/100)) ) :volumeWeight
            }
            if (vm.chargeableWeight < 45 && vm.chargeableWeight > 0) {
                vm.$bus.emit('commmon-notification', null, 'Please contact customer service to place an order for goods below 45KG!')
                return false
            }
            // vm.MINPRICE = vm.chargeableWeight < 45 ? vm.NORMALPRICE : (vm.chargeableWeight < 100 ? vm.Q1PRICE : (vm.chargeableWeight < 300 ? vm.Q2PRICE : (vm.chargeableWeight < 500 ? vm.Q3PRICE : (vm.chargeableWeight < 1000 ? vm.Q4PRICE : vm.Q5PRICE)))); //取适用单价
            vm.MINPRICE =vm.chargeableWeight < 100 ? vm.Q1PRICE : (vm.chargeableWeight < 300 ? vm.Q2PRICE : (vm.chargeableWeight < 500 ? vm.Q3PRICE : (vm.chargeableWeight < 1000 ? vm.Q4PRICE : vm.Q5PRICE))); //取适用单价

            if(vm.MINPRICE==0.00){
                vm.freight=0
                return false;
            }
            vm.freight = parseFloat(vm.chargeableWeight * vm.MINPRICE).toFixed(2); //基础运费
            if( vm.freight=='NaN'){
                vm.freight=0
            }

        },

        cellClass: function (e) {
            var rowIndex = e.rowIndex,
                columnIndex = e.columnIndex
            var _this = this,
                chosenRowIdx = -1, //_this.highlightedRowIndex,
                className = '',
                density = _this.density
            var chosenColumnIdx = -1;
            if (_this.chargeableWeight >= 45) {
                chosenColumnIdx = 0
            }
            if (_this.chargeableWeight >= 100) {
                chosenColumnIdx = 1
            }
            if (_this.chargeableWeight >= 300) {
                chosenColumnIdx = 2
            }
            if (_this.chargeableWeight >= 500) {
                chosenColumnIdx = 3
            }
            if (_this.chargeableWeight >= 1000) {
                chosenColumnIdx = 4
            }

            if (_this.density) {
                for (var i = 0; i <  _this.baseRate.length ; i++) {
                    let unit = _this.baseRate[i],
                        top = unit.densityTopLine ? unit.densityTopLine : 10000,
                        bottom = unit.densityBottomLine ? unit.densityBottomLine : 1;
                    if (_this.density < top && _this.density >= bottom) {
                        chosenRowIdx = i
                        break;
                    }else{
                        chosenRowIdx=0
                    }
                }
            }else{
                chosenRowIdx=0
            }
            //

            if (rowIndex == chosenRowIdx) {
                className = 'highlight'
            }
            if (columnIndex == chosenColumnIdx) {
                className = 'highlight'
            }
            if (columnIndex == chosenColumnIdx && rowIndex == chosenRowIdx) {
                className = 'focus'
            }
            return className
        },


        // 国内报关*
        loadServeSource: function () {
            var url = '/api/product/charge/dep/list',
                formData = {
                    type: 0
                },
                successCallBack = function (response) {
                    if (response.depList) {
                        _this.chargeList = response.depList;
                        _this.chargeList.some((item, i) =>{
                            if(item.departure == _this.Departure){
                               _this.syscodeApply = item.departure
                               _this.applyChanged(_this.syscodeApply)
                                return true;
                            }
                        })
                    }

                },
                failCallBack = function (err) {

                },
                _this = this
            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)
        },
        // 国内报关费用
        applyChanged(value) {
            var _this = this;
            if (value != '') {
                var url = '/api/product/charge/list',
                    formData = {
                        departure: value,
                        type: '',
                        name: '报关费',
                        chargeType: ''
                    },
                    successCallBack = function (response) {
                        if (response.chargeList) {
                            var GNchargeList = response.chargeList;
                            if(GNchargeList.length>0){
                                GNchargeList.some((item, i) =>{
                                    if(item.departure == value){
                                        _this.chargePrice = item.chargePrice
                                        return true;
                                    }
                                })
                            }else{
                                _this.chargePrice=''
                            }

                        }

                    },
                    failCallBack = function (err) {

                    },
                    _this = this
                YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)


            }
        },
        // 国内提货
        loadTakeDelivery: function () {
            var url = '/api/product/delivery/city',
                formData = {
                    airport: this.Departure
                },
                successCallBack = function (response) {
                    if (response.cityList) {
                        _this.takeDeliveryInfoList = response.cityList;

                    }

                },
                failCallBack = function (err) {

                },
                _this = this
            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)
        },

        cityChanged(value) {
            var _this = this;
            if (value != '') {
                _this.loadingCity = true
                var url = '/api/product/delivery/area',
                    formData = {
                        airport: this.Departure,
                        city: value,
                    },
                    successCallBack = function (response) {
                        if (response.areaList) {
                            _this.deliveryInfoList = response.areaList;
                            _this.loadingCity = false
                            _this.cityNames=value
                            _this.areaNames=''
                        }

                    },
                    failCallBack = function (err) {

                    },
                    _this = this
                YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)

            } else {
                _this.deliveryInfoList = []
                _this.areaNames = ''
            }

        },
        // 国内提货费用
        selectSyscode: function (areaNames) {
            var url = '/api/product/delivery/price',
                formData = {
                    airport: this.Departure,
                    city: this.cityNames,
                    area: areaNames,
                    weight: this.grossWeight ? this.grossWeight : 0,
                    volume: this.volume ? this.volume : 0,
                },
                successCallBack = function (response) {
                    if (response.price) {
                        if(response.price){
                            _this.nationPrice = response.price;
                        }else{
                            _this.nationPrice=0
                        }
                        if(areaNames!=''){
                            _this.areaNames = areaNames
                        }else{
                            _this.areaNames=''
                        }

                    }
                },
                failCallBack = function (err) {

                },
                _this = this
            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)
        },
        // 海外服务下拉框
        loadForeignServeList: function () {
            var url = '/api/product/charge/dep/list',
                formData = {
                    type: 1
                },
                successCallBack = function (response) {
                    if (response.depList) {
                        _this.foreignServeList = response.depList;
                        _this.foreignServeList.sort(function(a,b){
                            return a.departure.localeCompare(b.departure)
                        })
                        _this.foreignServeList.some((item, i) =>{
                            if(item.departure ==  _this.Destination){
                                _this.cityDestination = item.departure
                                _this.cityDestinationChanged(_this.cityDestination)
                                return true;
                            }
                        })

                    }
                },
                failCallBack = function (err) {

                },
                _this = this
            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)
        },
        // 海外服务费用
        cityDestinationChanged(value) {
            var _this = this;
            if (value != '') {
                var url = '/api/product/charge/list',
                    formData = {
                        departure: value,
                        type: 1,
                        name: '',
                        chargeType: '',
                    },
                    successCallBack = function (response) {
                if (response.chargeList.length ) {
                            _this.foreignChargeList=response.chargeList

                            for (var i = 0; i < _this.foreignChargeList.length; i++) {
                                if (_this.foreignChargeList[i].departure == value) {
                                    _this.cityDestination=_this.foreignChargeList[i].departure
                                    if(_this.foreignChargeList[i].currencyUnit!='CNY'){
                                        _this.unit=_this.foreignChargeList[i].currencyUnit
                                        _this.currencyUnit=_this.translation(_this.foreignChargeList[i].currencyUnit);
                                    }
                                    // chargeUnit=3另计算
                                    if (_this.foreignChargeList[i].chargeUnit == 3 && _this.grossWeight!=null) {
                                        _this.foreignChargeList[i].chargePrice = Number((_this.foreignChargeList[i].chargePrice * _this.grossWeight).toFixed(2))
                                        if(_this.foreignChargeList[i].miniPrice){
                                            _this.foreignChargeList[i].chargePrice = _this.foreignChargeList[i].chargePrice < _this.foreignChargeList[i].miniPrice ? _this.foreignChargeList[i].miniPrice : _this.foreignChargeList[i].chargePrice;
                                        }

                                    }

                                    // _this.foreignChargeList[i].currencyUnit = _this.translation(_this.foreignChargeList[i].currencyUnit);


                                }
                            }
                            _this.dollar=_this.sumPrice(_this.foreignChargeList).toFixed(2)
                            _this.CNY=_this.priceCNY(_this.foreignChargeList).toFixed(2)
                            _this.loadRate();
                        }

                    },
                    failCallBack = function (err) {

                    },
                    _this = this
                YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)


            }
        },
        // 海外费用
        priceCNY:function(arr){
            let cny=0
            for(var i=0;i<arr.length;i++){
                if(arr[i].currencyUnit=="人民币" || arr[i].currencyUnit=='CNY'){
                    cny += Number( arr[i].chargePrice);
                }
            }
            return cny;
        },
        sumPrice:function(arr){
            let dollar=0
            for(var i=0;i<arr.length;i++){
                if(arr[i].currencyUnit !='CNY' && arr[i].currencyUnit !="人民币" && arr[i].currencyUnit==arr[i].currencyUnit){
                    dollar += Number( arr[i].chargePrice);
                }
            }
            return dollar;
        },


        // 汇率 exchangeRateDate
        loadRate: function () {
            var _this = this;
            var url = '/ae/exchangeRate?exchangeRateDate'
            axios.get(url).then(function (res) {
                var rateData = res.data.data;
                rateData.some((item, i) =>{
                    if(_this.currencyUnit == _this.translation(item.currency)){
                        _this.Rate = item.exchangeRate;
                        return true;
                    }
                })

            }).catch(function (err) {

            })

        },
        translation: function (val) {
            let map = { 'FAF': '法郎', 'HKD': '港元', 'CHF': '瑞郎', 'USD': '美元','JPY':'日元','CAD':'加元','GBP':'英镑','NLG':'荷兰盾','DEM':'马克',
            'BEF':'比郎','AUD':'澳元','CNY':'人民币','EUR':'欧元','NZD':'纽币'}
            return map[val]
        },
        resolveParam: function (val) {
            if (val == 'null' || val == 'undefined' || val == null || val == undefined) {
                val = ''
            }
            return val;
        },
        timeAdd(str) {
            if (str < 10) {
                str = '0' + str;
            }
            return str
        },
        toLogin: function(){
            let url = ''
            !!this.pieces && (url += '&pieces='+ this.pieces)
            !!this.grossWeight && (url += '&weight=' + this.grossWeight)
            !!this.volume && (url += '&volume=' + this.volume)
            !!this.flightDate && (url += '&flightdate=' + this.flightDate)
            !!this.syscodeApply && (url += '&syscodeApply=' + this.syscodeApply)
            !!this.chargePrice && (url += '&chargePrice=' + this.chargePrice)
            !!this.cityNames && (url += '&cityNames=' + this.cityNames)
            !!this.areaNames  && (url += '&areaNames=' + this.areaNames)
            !!this.nationPrice && (url += '&nationPrice=' + this.nationPrice)
            url += '&cityDestination=' + this.cityDestination
            // this.$bus.emit('toAccountLogin', window.location.href + url)
        },
        orderFactory: function () {
            var _this = this
            if (!_this.pieces || !_this.grossWeight || !_this.volume) {
                _this.$bus.emit('commmon-notification', null, 'Please fill in the packages, gross weight and volume of the goods!')
                return false
            }
            if (_this.chargeableWeight < 45 && _this.chargeableWeight > 0) {
                _this.$bus.emit('commmon-notification', null, 'Please contact customer service to place an order for goods below 45KG!')
                return false
            }
            if (!_this.flightDate) {
                _this.$bus.emit('commmon-notification', null, 'Please select a flight date!')
                return false
            }
            if( _this.freight==0){
                _this.isSure()
                if (_this.freight==0) {
                    _this.$bus.emit('commmon-notification', null, 'Please modify the cargo parameters!')
                    return false
                }
            }
             if(_this.productType !='FLA'){
                var newData = _this.flightDate.replace(/-/g, ".");
                if (new Date(newData) < new Date(_this.StartDate.substring(0, 10)) || new Date(newData) > new Date(_this.EndDate.substring(0, 10))) {

                    _this.$bus.emit('commmon-notification', null, 'The flight date is not within the validity period, and the order cannot be placed!')
                    return false
                }
             }
             window.KF5SupportBoxAPI.identify({
                "metadata": [{
                        name: 'departure',
                        value: _this.Departure
                    },
                    {
                        name: 'destination',
                        value: _this.Destination
                    },
                    {
                        name: 'productCode',
                        value: _this.productcode
                    },
                    {
                        name: 'airline',
                        value: _this.airlineCode
                    },
                    {
                        name: 'pieces',
                        value: _this.pieces
                    },
                    {
                        name: 'grossWeight',
                        value: _this.grossWeight
                    },
                    {
                        name: 'volume',
                        value: _this.volume
                    },
                    {
                        name: 'flightDate',
                        value: _this.flightDate
                    },
                    {
                        name: 'email',
                        value: _this.user.email
                    },
                ]
            })
            window.KF5SupportBoxAPI.open();
        },
        gotoSaas: function() {
            if (window.parent) {
                let order = {
                    key: 'create-yctop-order',
                    departure: this.Departure,
                    destination: this.Destination,
                    airline: this.AirLine,
                    productCode: this.productcode,
                    priceCode: this.pricecode,
                    volume : this.volume,
                    grossWeight: this.grossWeight,
                    pieces: this.pieces,
                    flightDate: this.flightDate,
                }
                window.parent.postMessage(order, '*');
            } else {
                console.log('yctop is not in inframe')
            }
        },
        postLog: function () {
            var vm = this;
            var requestFrom = document.referrer;
            if (requestFrom.indexOf("?") > -1) {
                requestFrom = requestFrom.substring(0, requestFrom.indexOf("?"));
            }
            var requestTo = window.location.href;
            if (requestTo.indexOf("?") > -1) {
                requestTo = requestTo.substring(0, requestTo.indexOf("?"));
            }
            var actionType = "DETAIL";
            var businessCode = "FLA";
            var phoneNo = vm.user.mobile;
            var phoneNoAttribution = "";
            var departure = vm.Departure;
            var destination = vm.Destination;
            var productPrice = vm.Q5PRICE;
            var requesterIp = window.sessionStorage.getItem('clientIP');

            var params = new URLSearchParams();
            params.append("requestFrom", requestFrom);
            params.append("requestTo", requestTo);
            params.append("actionType", actionType);
            params.append("businessCode", businessCode);
            params.append("phoneNo", phoneNo);
            params.append("phoneNoAttribution", phoneNoAttribution);
            params.append("departure", departure);
            params.append("destination", destination);
            params.append("productPrice", productPrice);
            params.append("requesterIp", requesterIp);
            YC_REQUEST_HANDLER.LogAccess(params);
        },

    }
};
</script>
